import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginLeftBannerComponent } from '../login-left-banner/login-left-banner.component';
import { HeaderPreLoginComponent } from '../header-pre-login/header-pre-login.component';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { RouterModule } from '@angular/router';
import { CuttoffTimingModalComponent } from './cuttoff-timing-modal/cuttoff-timing-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CuttoffTimingModalBseComponent } from './cuttoff-timing-modal-bse/cuttoff-timing-modal-bse.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpComponent } from './otp/otp.component';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ClientProfileModelComponent } from './client-profile-model/client-profile-model.component';
import { AddNomineeComponent } from './add-nominee/add-nominee.component';
import { ShortNumberPipe } from '../filters/short-number.pipe';
import { NomineePopUpComponent } from '../nominee-pop-up/nominee-pop-up.component';

@NgModule({
  declarations: [
    LoginLeftBannerComponent,
    HeaderPreLoginComponent,
    HeaderComponent,
    FooterComponent,
    ContactUsComponent,
    ConfirmationDialogComponent,
    CuttoffTimingModalComponent,
    CuttoffTimingModalBseComponent,
    TermsAndConditionsComponent,
    OtpComponent,
    ClientProfileModelComponent,
    AddNomineeComponent,
    ShortNumberPipe,
    NomineePopUpComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot() // ModalModule comes from ngx-bootstrap
  ],
  exports: [
    LoginLeftBannerComponent,
    HeaderPreLoginComponent,
    HeaderComponent,
    FooterComponent,
    ContactUsComponent,
    ConfirmationDialogComponent,
    CuttoffTimingModalComponent,
    CuttoffTimingModalBseComponent,
    TermsAndConditionsComponent,
    OtpComponent,
    ClientProfileModelComponent,
    AddNomineeComponent,
    ShortNumberPipe,
    NomineePopUpComponent
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    OtpComponent,
    AddNomineeComponent
  ],
  providers: [OtpComponent, ConfirmationDialogComponent, AddNomineeComponent]
})
export class SharedModule {}
